import type { SVGProps } from "react";

/** Coin with $ dropping into a donation slot — matches footer CTA reference. */
export function DonationCoinIcon({
  size = 18,
  className,
  ...props
}: SVGProps<SVGSVGElement> & { size?: number }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      aria-hidden
      {...props}
    >
      <circle cx="12" cy="8.5" r="5.25" />
      <path d="M12 6.25v4.5" />
      <path d="M10.5 7.35c.4-.4.9-.6 1.5-.6.95 0 1.55.5 1.55 1.2s-.7 1.15-1.65 1.4c-.9.25-1.55.55-1.55 1.4 0 .8.7 1.3 1.65 1.3.6 0 1.15-.2 1.55-.6" />
      <path d="M4.5 18h15" />
      <path d="M6.5 18v1.25c0 .7.55 1.25 1.25 1.25h8.5c.7 0 1.25-.55 1.25-1.25V18" />
    </svg>
  );
}
